import { z } from 'zod'
import {
  HOUSE_NUMBER_MAX_LENGTH,
  STREET_AND_NUMBER_MESSAGES,
  normalizeHouseNumber,
} from '@/lib/utils/street'

export const LoginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1, 'Password required'),
  skipCartRestore: z.boolean().optional(),
  applyPreferredLanguage: z.boolean().optional(),
})

export const PASSWORD_MIN_LENGTH = 8

export type PasswordMessages = {
  minLength?: string
  capitalLetter?: string
  smallLetter?: string
}

export const createPasswordSchema = (messages: PasswordMessages = {}) =>
  z
    .string()
    .min(PASSWORD_MIN_LENGTH, messages.minLength)
    .regex(/[A-Z]/, messages.capitalLetter)
    .regex(/[a-z]/, messages.smallLetter)

export const phoneNumberSchema = z
  .string()
  .refine((val) => /^\+?[\d\s\-\/]+$/.test(val), {
    message: 'Please enter a valid phone number',
  })

export const zipCodeSchema = z.string().refine((val) => /^\d+$/.test(val), {
  message: 'Numeric characters only',
})

export const houseNumberPayloadSchema = z
  .string()
  .refine(
    (value) => normalizeHouseNumber(value).length <= HOUSE_NUMBER_MAX_LENGTH,
    { message: STREET_AND_NUMBER_MESSAGES.houseNumberTooLong },
  )
  .optional()
